import Vue from 'vue';
//配置路由
import VueRouter from 'vue-router'
Vue.use(VueRouter);
//1.创建组件
import Index from '@/views/index'
import Home from '@/views/home'
import Login from '@/views/login'
import NotFound from '@/views/404'
import UpdatePassword from '@/views/update-password'
import pay from '@/views/pay'
import register from '@/views/register'
import center from '@/views/center'
	import yonghu from '@/views/modules/yonghu/list'
	import chayuanxinxi from '@/views/modules/chayuanxinxi/list'
	import chat from '@/views/modules/chat/list'
	import chargerecord from '@/views/modules/chargerecord/list'
	import chayeleixing from '@/views/modules/chayeleixing/list'
	import orders from '@/views/modules/orders/list'
	import discusschayexinxi from '@/views/modules/discusschayexinxi/list'
	import chayexinxi from '@/views/modules/chayexinxi/list'
	import chanong from '@/views/modules/chanong/list'
	import config from '@/views/modules/config/list'
	import chayeshengchan from '@/views/modules/chayeshengchan/list'
	import caizhaianpai from '@/views/modules/caizhaianpai/list'


//2.配置路由   注意：名字
export const routes = [{
	path: '/',
	name: '系统首页',
	component: Index,
	children: [{
		// 这里不设置值，是把main作为默认页面
		path: '/',
		name: '系统首页',
		component: Home,
		meta: {icon:'', title:'center', affix: true}
	}, {
		path: '/updatePassword',
		name: '修改密码',
		component: UpdatePassword,
		meta: {icon:'', title:'updatePassword'}
	}, {
		path: '/pay',
		name: '支付',
		component: pay,
		meta: {icon:'', title:'pay'}
	}, {
		path: '/center',
		name: '个人信息',
		component: center,
		meta: {icon:'', title:'center'}
	}
	,{
		path: '/yonghu',
		name: '用户',
		component: yonghu
	}
	,{
		path: '/chayuanxinxi',
		name: '茶园信息',
		component: chayuanxinxi
	}
	,{
		path: '/chat',
		name: '在线咨询',
		component: chat
	}
	,{
		path: '/chargerecord',
		name: '充值记录',
		component: chargerecord
	}
	,{
		path: '/chayeleixing',
		name: '茶叶类型',
		component: chayeleixing
	}
	,{
		path: '/orders/:status',
		name: '订单管理',
		component: orders
	}
	,{
		path: '/discusschayexinxi',
		name: '茶叶信息评论',
		component: discusschayexinxi
	}
	,{
		path: '/chayexinxi',
		name: '茶叶信息',
		component: chayexinxi
	}
	,{
		path: '/chanong',
		name: '商家',
		component: chanong
	}
	,{
		path: '/config',
		name: '轮播图管理',
		component: config
	}
	,{
		path: '/chayeshengchan',
		name: '茶叶生产',
		component: chayeshengchan
	}
	,{
		path: '/caizhaianpai',
		name: '采摘安排',
		component: caizhaianpai
	}
	]
	},
	{
		path: '/login',
		name: 'login',
		component: Login,
		meta: {icon:'', title:'login'}
	},
	{
		path: '/register',
		name: 'register',
		component: register,
		meta: {icon:'', title:'register'}
	},
	{
		path: '*',
		component: NotFound
	}
]
//3.实例化VueRouter  注意：名字
const router = new VueRouter({
	mode: 'hash',
	/*hash模式改为history*/
	routes // （缩写）相当于 routes: routes
})
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
export default router;
